import React, { Children, FC } from "react";
import { useTranslation } from "react-i18next";

import { ITextProps, Text } from "@/components/Text";

export interface IEmptyTextProps extends ITextProps {}

export const EmptyText: FC<IEmptyTextProps> = props => {
  const { t } = useTranslation("common");

  return (
    <Text color="grey3" {...props}>
      {Children.count(props.children) === 0 ? t("COMPONENTS.EMPTY_TEXT") : props.children}
    </Text>
  );
};
